<template>
	<div class="darkmodule">
      <div class="container">
        <h2 class="darkmodule__header">Почему нас выбирают</h2>
        <h3 class="darkmodule__title">Инженерный подход</h3>
        <p>Мы берем оплату с клиента только тогда, когда все технические нюансы проекта разобраны и не осталось не заданных вопросов к технической реализации. Благодаря этому мы всегда сдаем проекты в срок, а стоимость реализации не меняется в процессе. Если мы взялись за проект - значит он будет сделан без «сюрпризов» для ваших бизнес-процессов.</p>
        <h3 class="darkmodule__title mt-50">Решение любых задач</h3>
        <p>Мы не боимся технических сложностей и способны глубоко погрузиться в любую тематику, чтобы решить задачу клиента. Благодаря этому нам удается успешно сдавать то, за что другие команды в принципе не берутся.</p>
        <h3 class="darkmodule__title mt-50">Здоровый перфекционизм</h3>
        <p>Здравые требования к самим себе помогают нам делать архитектурно правильные, масштабируемые решения, которые легко поддерживать и развивать. Разработанные нами проекты годами работают и развиваются без перебоев и необходимости «переписать все заново».</p>
        <h3 class="darkmodule__title mt-50">Внимание к деталям</h3>
        <p>Мы стараемся работать превосходя ожидания клиентов и прорабатываем каждую деталь продукта, даже если какие-то моменты были упущены или не детализированы в ТЗ.</p>
        <h3 class="darkmodule__title mt-50">Долгосрочная поддержка</h3>
        <p>Обеспечиваем полноценную поддержку всех разработанных проектов годами, независимо от обстоятельств. Ни один наш клиент еще не оставался наедине с техническими задачами после сдачи проекта.</p>
      </div>
    </div>
</template>
<script>
	const name = 'DarkModule'
	export default {
		name
	}
</script>
